export default {
  banner: {
    addTaxIdTitle: 'Have a {{taxType}}?',
    addTaxIdText: '{{children}} Please add it to the Tax Policies section of your account.',
    addTaxIdLinkText: 'Submit my tax info.',
    VAT: 'VAT ID',
    GST: 'GST ID',

    // Read only by the legacy InternationalTaxIdBanner. Delete these together
    // with that component once Core has switched to the nag-based banner.
    euAddTaxId: 'Have a {{children}}? Please add it to the Tax Policies section of your account.',
    buttonText: 'Submit my tax info',
    learnMore: 'Learn more',
    caTaxTitle: 'Reverb began assessing tax on fees for sellers in Canada on 12 August 2024.',
    caTaxContent: 'You can learn more about this tax policy in our Help Center.',
  },
};
